export default __webpack_public_path__ + "static/thegrowthacademy-7ab96bb05c21474b3ecf11b777037a43.svg";